






import Vue from 'vue'
import { SocialMediaStats } from '@/types/ops'
import Interval from '@/components/Common/Interval'

export default Vue.extend({
  name: 'SocialMediaNextCheck',
  data: () => ({
    now: (new Date).getTime()
  }),
  computed: {
    socialMediaBackend (): SocialMediaStats|null {
      return this.$store.direct.state.opsmonitor.socialMediaMonitor
    },
    nextCheck (): number {
      if (this.socialMediaBackend === null) {
        return 0
      } else {
        const lastChecked = Math.round((this.now - this.socialMediaBackend.last_checked) / 1000)
        const seconds = Math.max(0, this.socialMediaBackend.interval - lastChecked)
        return seconds
      }
    }
  },
  methods: {
    clockUpdate (): void {
      this.now = Date.now()
    }
  },
  components: {
    Interval
  }
})
